exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#viewer {\n  background-color: black;\n  width: 100%;\n}\n\n.loadingTextDiv {\n  color: var(--text-secondary-color);\n  font-size: 30px;\n}\n\n", ""]);

